rdproduct = (function(){
  var product,is_live,selected_variant,autorefill_on,recharge_data,hidden_options,visible_options,bottle_count;
  var bottle_counts={
    "B-RMSX":2,
    "B-RM1X":3,
    "B-RM2X":3,
    "B-RM3X":6,
    "B-RM4X":6,
    "B-RM5X":6,
    "B-RM6X":6,
    "B-RM7X":6
  };
//format:
//<regular_variant>:[<recharge_variant>,<months>,<recharge subscription id>]
//see recharge_upsell.js
//only products config'd here will go straight to checkout
  var config={
  	19902484358:[23967398150,1,18421],
    20408670790:[23967398214,3,18421],
    20408670854:[23967398278,6,18421],
  };
  var self={
    
    init:function(){
      //Shopify.setParam=function(){}; //TOTAL hack. so variants don't change the history
      is_live=!document.location.search.match(/live=0/); //just add ?live=0 to see errors in console instead of logging      
      try{
        $('.offer_newline').hide();
    	$('select[data-option^=option],input[id^=autodeliver]').on('change',self.product_change);
      	$('<span></span>').attr('id','per-bottle').addClass('per-bottle').insertAfter($('.product-price'))
        //use meta instead. old way: query ajax api  
      	//if(!meta){
        	//$.getJSON($('link[rel=canonical]').attr('href')+'.js',function(r){product=r;});
        //}
        /*for(var i in meta.product.variants){
        	var v = meta.product.variants[i];
          	if(!v.sku.match(/\.\/d+$/)){ //fetch the metafields for bottle count if sku has no info
            	console.log('fetch '+v.id); 
            }
        }*/
        self.product_change();
        if(!is_live){
          $('#add-to-cart').bind('click',self.bypass_checkout);
        }
      }catch(err){
      	self.log_error("rdproduct.init() error: "+err);        
      }
    },
    log_error:function(err){
      if(is_live){
      	$.get('https://io.realdose.com/error',{e:err});
      }else{
        console.log(err);
      }
    },
    bypass_checkout:function(e){
      e.stopPropagation();
      e.preventDefault();
      straight_to_checkout=config[selected_variant];
      var data={
        "id":selected_variant,
        "quantity":1
      };
      if(autorefill_on && config[selected_variant]){
        var shopify_cart_id = self.get_cookie('cart');
		var subscription_interval = config[selected_variant][1];
      	var subscription_id = config[selected_variant][2];
      	data.id = config[selected_variant][0];
        data["properties[shipping_interval_frequency]"] = subscription_interval;
        data["properties[shipping_interval_unit_type]"]="Months";
        data["properties[subscription_id]"] = subscription_id;
        try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
        var recharge_url = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=realdose.myshopify.com&cart_token="+shopify_cart_id+"&"+ga_linker;
      }
      $.post('/cart/clear.js',{},function(d){
        $.post('/cart/add.js',data,function(r){
            var cart_url=straight_to_checkout?'/checkout':'/cart';
            if(autorefill_on && straight_to_checkout){
              cart_url = recharge_url;
            }
            document.location.href=cart_url;
        },'json');
       },'json');
      	return false;
    },
    product_change:function(){
      /*lock the dom change listener for recharge's logic so it doesn't overwrite our changes*/
      //  jfh mod console.log('product change locking first_time_'+meta.product.id);
      // jfh mod var temp_lock = setInterval(function(){window['first_time_'+meta.product.id] = false;},1);

      try{
        selected_variant=parseInt($('#product-select').val());
        console.log(selected_variant);
        autorefill_on = !!$('input[id^=autodeliver_on]:checked').length;
        if(autorefill_on){
          $('.offer_newline').show();
        }else{
          $('.offer_newline').hide();
        }
        recharge_data = window["variant_price_to_discount_price_map_"+meta.product.id];
		if(!recharge_data)return; //stops errors on non-recharge enabled products
        hidden_options = $('select#product-select option');
        visible_options = $('select#product-select-option-1 option');
        if(!visible_options.length){
        	visible_options = $('select#product-select-option-0 option');  
        }
      	//figure prices
        //for(var p in product.variants){
      	for(var p in meta.product.variants){
            var variant = meta.product.variants[p];
            //var variant = product.variants[p];
            var sku_match = variant.sku.match(/\.(\d+)$/);
          if(sku_match){
            bottle_count = parseInt(sku_match[1]);
          }else{
            bottle_count = bottle_counts[variant.sku];  
          }
          	//redraw select option wording
            for(var s in hidden_options){
                var option = hidden_options[s];
                if(option.value!=variant.id)continue;
                    for(var o in visible_options){
                      	if(o!=s)continue;
                    	var voption = visible_options[o];
                        var reg_price = variant.price/100;
                        var disc_price = recharge_data[variant.id].discount_variant_price;
                        var per_bottle = parseFloat((autorefill_on?disc_price:reg_price)/bottle_count).toFixed(2);
                      	if(parseInt(per_bottle)==per_bottle) per_bottle=parseInt(per_bottle);
                        $(voption).html($(voption).html().replace(/\$[^ ]+/,'$'+per_bottle));
                    }

            }
          	//if current selection, also update the price
        	if(variant.id==selected_variant){
             // var chosen = meta.product.variants[p];
              var total_price=variant.price/100;
              var per_bottle = total_price/bottle_count;
              var discount_per_bottle = recharge_data[variant.id].discount_variant_price/bottle_count;
              var show_price = parseFloat(autorefill_on?discount_per_bottle:per_bottle).toFixed(2);
              var all_bottle_price = (show_price*bottle_count).toFixed(2);
              if(parseInt(show_price)==show_price) show_price=parseInt(show_price);
              if(parseInt(all_bottle_price)==all_bottle_price) all_bottle_price=parseInt(all_bottle_price);
              if(bottle_count>1){
              	$('#per-bottle').html(' ($'+show_price+' each)');
                $('#product-main-wrapper .product-price').css('display','inline');
              }else{
                $('#per-bottle').html('');
                $('#product-main-wrapper .product-price').css('display','inline');
              }
              console.log('setting price to '+all_bottle_price);
              $('#product-main-wrapper .product-price').html('$&nbsp;'+all_bottle_price);
        	}
          //jfh mod setTimeout(function(){clearInterval(temp_lock);},1400);
      	}
      }catch(err){
        self.log_error("rdproduct.product_change() error: "+err);
      }
      /*setTimeout(function(){console.log('unlocking '+meta.product.id+' '+window['lock_'+meta.product.id]);
                            clearInterval(hold_lock);
                            window['lock_'+meta.product.id] = false;},1400);*/
     //setTimeout(function(){clearInterval(temp_lock);},1400);
    },
    get_cookie:function(name){ 
      return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2];
    },
    
  }; // end self
  return self;
})();

$(rdproduct.init);